export default __webpack_public_path__ + "static/media/bill.88cb5747.png";